/* Cart drawer (snippets/tg-cart-extras.liquid, brief §8j). Loaded on every page with the drawer shell.
   1. "Add" on the one suggestion: adds it and re-renders the drawer.
   2. Free opener + koozie (decision 16): [data-tg-gift] says how many sets the cart should hold (one per Trekker)
      and which gift lines it has; this adds or removes lines (property _tg_gift) until they match. The automatic
      Buy X get Y discount (buy 1 Trekker, get 2 of opener/koozie) makes them $0; it can only pick the right two because
      this keeps exactly one of each per Trekker. Shopify can split a line while it allocates, so lines are totalled
      per variant. Runs on load and 500ms after the drawer settles (so
      Horizon's own quantity changes finish first); stops after 3 tries.
   3. Horizon opens the drawer as a non-modal dialog: a click on the navy scrim (the drawer host, see tailgater-cart.css)
      closes it, and focus stays inside while it's open: focus stops at both ends of the dialog (snippets/cart-drawer)
      send Tab past the last button (often a wallet iframe) to the top and Shift+Tab past the first to the bottom.
   4. (v32, stranger run 6) Counts include the free gifts: the drawer lists the $0 opener + koozie lines, so the badge
      counts every line the shopper sees (it read 1 with 3 lines in the cart). The old subtraction patch is gone.
   5. Phones: the express wallets move from the sticky footer into [data-tg-pay-slot] at the end of the list (and back on
      wider screens), so the footer is only total + Check out. Moved, not copied: two copies make Shopify stack the desktop row. */
(function () {
  if (window.tgCartJs) return;
  window.tgCartJs = true;
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var busy = false;
  var tries = 0;

  function post(path, body) {
    body.sections = 'cart-drawer-section';
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(path); return r.json(); });
  }

  function render(data) {
    var html = data && data.sections && data.sections['cart-drawer-section'];
    var cur = document.querySelector('#cart-drawer .cart-drawer__inner');
    if (html && cur) {
      var next = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner');
      if (next) cur.replaceWith(next);
    }
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var icon = document.querySelector('cart-icon');
      if (icon && icon.renderCartBubble) icon.renderCartBubble(cart.item_count, false);
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'tg-cart', data: { itemCount: cart.item_count } } }));
      sync();
    });
  }

  function sync() {
    var el = document.querySelector('#cart-drawer [data-tg-gift]');
    if (!el || busy || tries >= 3) return;
    var want = Number(el.getAttribute('data-tg-gift')) || 0;
    var ids = el.getAttribute('data-tg-gift-ids').split(',').filter(Boolean).map(Number);
    var have = {};
    el.getAttribute('data-tg-gift-have').split(',').filter(Boolean).forEach(function (s) {
      var p = s.split(':');
      var h = have[p[0]] || (have[p[0]] = { qty: 0, keys: [] });
      h.qty += Number(p[1]);
      h.keys.push(p.slice(2).join(':'));
    });
    var updates = {};
    var adds = [];
    Object.keys(have).forEach(function (id) {
      var keep = ids.indexOf(Number(id)) > -1 ? want : 0;
      if (have[id].qty === keep) return;
      have[id].keys.forEach(function (key, i) { updates[key] = i === 0 ? keep : 0; });
    });
    ids.forEach(function (id) {
      if (want > 0 && !have[id]) adds.push({ id: id, quantity: want, properties: { _tg_gift: '1' } });
    });
    if (!adds.length && !Object.keys(updates).length) { tries = 0; return; }
    busy = true;
    tries += 1;
    var step = Object.keys(updates).length ? post('cart/update.js', { updates: updates }) : Promise.resolve(null);
    step
      .then(function (data) { return adds.length ? post('cart/add.js', { items: adds }) : data; })
      .then(function (data) { busy = false; return render(data); })
      .catch(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tg-cx-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    var g = btn.getAttribute('data-tg-guide');
    var it = { id: Number(btn.getAttribute('data-tg-cx-add')), quantity: 1 };
    if (g) it.properties = { _tg_guide: g };
    post('cart/add.js', { items: [it] })
      .then(function (data) {
        /* v34: the guide next-item card's add (guide-impulse spec §6), on success only. */
        if (g) {
          if (window.gtag) gtag('event', 'drawer_next_add', { guide: g, product: btn.getAttribute('data-tg-handle') || '' });
          if (window.clarity) clarity('event', 'drawer_next_add');
        }
        return render(data);
      })
      .catch(function () { btn.disabled = false; });
  });

  var back = false;
  function host() { var h = document.getElementById('cart-drawer'); return h && h.hasAttribute('open') ? h : null; }
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') back = e.shiftKey; }, true);
  document.addEventListener('focusin', function (e) {
    var h = host();
    if (!h) return;
    var trap = e.target.getAttribute && e.target.getAttribute('data-tg-trap');
    if (h.contains(e.target) && !trap) return;
    var f = [].filter.call(h.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]), iframe'), function (el) { return el.offsetParent; });
    var toEnd = trap ? trap === 'start' : back;
    if (f.length) (toEnd ? f[f.length - 1] : f[0]).focus();
  });
  document.addEventListener('click', function (e) {
    var h = host();
    if (h && e.target === h) { var x = h.querySelector('.theme-drawer__close-button'); if (x) x.click(); }
  });

  var phone = window.matchMedia('(max-width: 749px)');
  function placeWallets() {
    var slot = document.querySelector('#cart-drawer [data-tg-pay-slot]');
    var ctas = document.querySelector('#cart-drawer .cart__ctas');
    var w = document.querySelector('#cart-drawer .additional-checkout-buttons');
    if (!slot || !ctas || !w) return;
    var target = phone.matches ? slot : ctas;
    if (w.parentNode !== target) target.appendChild(w);
  }
  function watch() {
    var drawer = document.getElementById('cart-drawer');
    var timer;
    if (drawer) new MutationObserver(function () { placeWallets(); clearTimeout(timer); timer = setTimeout(sync, 500); }).observe(drawer, { childList: true, subtree: true });
    if (phone.addEventListener) phone.addEventListener('change', placeWallets);
    placeWallets();
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
